import { Injectable, inject } from '@angular/core';
import { Resolve } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { UserSettingsAPIService } from 'src/app/pages/help-and-settings/user-settings/api/user-settings-api.service';
import { UserSettingsStartPageUtil } from 'src/app/pages/help-and-settings/user-settings/user-settings-start-page.util';
import { PortalPath } from '../../routes/app.types';

@Injectable({
  providedIn: 'root'
})
export class StartPageNameResolver implements Resolve<PortalPath> {
  private readonly userService = inject(UserSettingsAPIService);

  resolve(): Observable<PortalPath> {
    return this.userService.read().pipe(
      map(userSettings => UserSettingsStartPageUtil.getPathByCodename(userSettings.startPage)),
      catchError(() => of(PortalPath.healthMonitor))
    );
  }
}
